import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from '@/src/pages/ErrorPage';

interface RootErrorBoundaryProps {
  children: ReactNode;
}

const RootErrorBoundary = ({ children }: RootErrorBoundaryProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>{children}</ErrorBoundary>
  );
};

export default RootErrorBoundary;
